<script>
import { defineComponent, ref, computed } from 'vue-demi'
import service from '@/service/correction'
export default defineComponent({
  props: {
    content: {
      type: String,
      default: ''
    },
    classCorrectType: {
      type: String,
      default: ''
    },
    lessonInfo: {
      type: Object,
      default: () => {}
    },
    recordNum: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const studentList = ref([])
    const selectedIndex = ref(0)
    const spinning = ref(false)
    let handle = null
    /**
     * @description 获取数据
     */
    const getStudentList = () => {
      const { classCorrectType } = props
      const { lessonId, xkhTeacherCourseId, classTypeId } = props.lessonInfo
      spinning.value = true
      service.getCountList({
        classTypeId,
        classCorrectType,
        lessonId,
        xkhTeacherCourseId
      }).then(res => {
        studentList.value = res
      }).finally(() => { spinning.value = false })
    }

    const handleVisibleChange = visible => {
      if (visible) {
        handle = setTimeout(() => {
          getStudentList()
        }, 0)
      } else {
        handle && clearTimeout(handle)
      }
    }

    const handleStudentClick = index => {
      selectedIndex.value = index
    }

    /**
     * @description 颜色
     */
    const color = computed(() => {
      const { correctionDivisionNum } = props.lessonInfo
      if (correctionDivisionNum > 0) return '#ec574c'
      return '#5db748'
    })
    /**
     * 无数据不展示
     */
    const hidePopver = computed(() => props.recordNum === 0)

    return {
      spinning,
      color,
      hidePopver,
      selectedIndex,
      studentList,
      handleVisibleChange,
      getStudentList,
      handleStudentClick
    }
  },
  render() {
    const _renderSlot = () => (
      <div class="content-wrap">
        <ul class="student-list">
          {
            this.studentList.map((item, index) => (
              <li class={['item', { selected: this.selectedIndex === index }]} onclick={() => this.handleStudentClick(index)}>{item.userName}</li>
            ))
          }
        </ul>
        <ul class="link-list">
          {
            this.studentList[this.selectedIndex].linkTypeList.map((item, index) => (
              <li class="item">{item.name}</li>
            ))
          }
        </ul>
      </div>
    )
    if (this.hidePopver) {
      return (<span class={['content', { cursors: this.hidePopver }]} style={{ color: this.color }}>{this.content}</span>)
    }
    return (
    <a-popover
      trigger="click"
      destroyTooltipOnHide={true}
      onclick={this.handlePopClick}
      onVisibleChange={this.handleVisibleChange}
      scopedSlots={{
        content: props => <a-spin spinning={this.spinning}> {this.studentList.length > 0 ? _renderSlot() : null } </a-spin>
      }}>
      <span class={['content', { cursors: this.hidePopver }]} style={{ color: this.color }}>{this.content}</span>
    </a-popover>
    )
  }
})
</script>
<style lang="less" scoped>
.content-wrap {
  :deep(.ant-spin-container) {
    display: flex;
  }
  display: flex;
  flex-direction: row;
  .student-list {
    flex: 1;
    border-right: 1px solid #eee;
    .item {
      width: 80px;
      text-align: center;
      padding: 6px 4px;
      &.selected {
        color: #3262FD;
      }
    }
  }
  .link-list {
    flex: 1;
    .item {
      width: 100px;
      text-align: center;
      padding: 6px 4px;
    }
  }
}
.content {
  cursor: pointer;
  &.cursors {
    cursor: default;
  }
}
</style>
